import React, { useEffect, useState } from 'react';
import Logo from '../img/aon_logo_light.webp';
import { Link } from 'react-router-dom';
import Image from './Image';

function Footer() {

    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        setCurrentYear(new Date().getFullYear());
    }, []);

    return (
      <>
        <div className='footer_section'>
            <div className="footer_wrapper">
                <div className='footer_block'>

                    <div className='footer_logo_wrapper'>
                        <Link to="/"><Image src={Logo} alt="Annals of Nursing" class="footer_logo"/></Link>
                    </div>

                    <h4 className='footer_title'>A Semi-Annual International Scientific Journal</h4>
                    
                </div>

                <div className='footer_block'>

                    <p className='footer_links_title'>Important Links</p>

                    <Link className='footer_link_element' to="/archive">Archive</Link>

                    <Link className='footer_link_element' to="/instructions">Instructions</Link>

                    <a href="https://aseestant.ceon.rs/index.php/AnnNur/login" target='_blank' rel="noreferrer" className='footer_link_element'>Submission</a>

                    <Link className='footer_link_element' to="/editorial">Editorial Board</Link>

                    <Link className='footer_link_element' to="/articles">Articles</Link>
                    
                </div>

                <div className='footer_block'>

                    <p className='footer_links_title'>Contact</p>

                    <Link className='footer_link_element' to="/contact">Contact Us</Link>
                    
                </div>
            </div>  

            <div className='footer_copyright'>
                <p className='footer_copyright_p'>Copyright © {currentYear} | Annals of Nursing</p>
            </div>
        </div>
      </>
    );
}

export default Footer;